// 그룹(병동) 드롭다운 값 동기화 유틸리티
// 여러 페이지가 각자 다른 localStorage 키를 사용하므로, 최소 수정으로 동기화한다.

const GROUP_KEYS = [
  "rcfg_selected_group", // 근무표 설정
  "rc_create_selected_group", // 근무표 만들기
  "hm_selected_group", // 근무자 관리
  "selectedGroupId", // 기타 스크립트 사용
  "rcfg_signed_group", // 오타로 쓰였던 케이스 대비
  "please_fix_key_selectedGroupId", // 임시 키 대비
] as const;

type GroupKey = (typeof GROUP_KEYS)[number];

function readFirstExisting(): string | null {
  for (const k of GROUP_KEYS) {
    const v = window.localStorage.getItem(k as GroupKey);
    if (v && v !== "null" && v.trim() !== "") return v;
  }
  return null;
}

let isSyncing = false;
function writeAll(value: string) {
  if (isSyncing) return;
  isSyncing = true;
  try {
    GROUP_KEYS.forEach((k) =>
      window.localStorage.setItem(k as GroupKey, value)
    );
  } finally {
    isSyncing = false;
  }
}

// 초기 동기화: 가장 먼저 발견되는 값을 전체 키로 확산
const initial = readFirstExisting();
if (initial) writeAll(initial);

// storage 이벤트로 탭 간 실시간 동기화
window.addEventListener("storage", (e) => {
  if (!e.key || !GROUP_KEYS.includes(e.key as GroupKey)) return;
  if (typeof e.newValue === "string" && e.newValue) writeAll(e.newValue);
});

// setItem 패치: 특정 키로 저장되면 모든 키로 반영
const originalSetItem = window.localStorage.setItem.bind(window.localStorage);
window.localStorage.setItem = function patchedSetItem(
  key: string,
  value: string
) {
  originalSetItem(key, value);
  if (GROUP_KEYS.includes(key as GroupKey)) writeAll(value);
};

export function getSelectedGroupId(): string | null {
  return readFirstExisting();
}

export function setSelectedGroupId(value: string) {
  writeAll(value);
}
